import React from 'react';
import cn from 'classnames';
import { calculatorState as store } from 'store';
import Icon from 'components/UI/Icon';
import { useTrans } from 'utils/localisation';
import * as styles from './MobileHeader.module.scss';

export default function MobileHeader({ calculatorID, totalInfo, total = true }) {
  const { clearCalculatorInfo } = store;
  const t = useTrans(['calculator']);

  return (
    <header className={cn(styles.header, !total && styles.flexEnd)}>
      {total && (
        <article className={styles.total}>
          {t('total')}:
          <div
            className={cn(
              styles.counter,
              Boolean(totalInfo.team || totalInfo.duration) && styles.active,
            )}
          >
            <p className={styles.item}>
              <Icon name="man-2-strong" className={cn(styles.icon, styles.man)} />
              {totalInfo.team}
            </p>
            <p className={cn(styles.item, Boolean(totalInfo.duration) && styles.active)}>
              <Icon name="calendar-3" className={cn(styles.icon, styles.man)} />
              {totalInfo.duration}
            </p>
          </div>
        </article>
      )}
      <button className={styles.clear} onClick={() => clearCalculatorInfo(calculatorID)}>
        {t('clearAll')}
      </button>
    </header>
  );
}
